export function getConfigEntryByKey(key) {
  const config = window.$dt?.objConfig || {};

  if (config && config.hasOwnProperty(key)) {
    return config[key];
  }
}
